export default {
  LoginTitle: '欢迎登录园所服务平台',
  // 操作
  Add: '添加',
  Edit: '编辑',
  Del: '删除',
  Confirm: '确认',
  Cancel: '取消',
  Next: '下一步',
  Back: '返回',
  Disable: '停用',
  Enable: '启用',
  Close: '关闭',
  Operation: '操作',
  // 提示
  PleaseInput: '请输入',
  PleaseSelect: '请选择',
  PhoneFormatError: '手机号格式错误',
  // 常用字段
  Name: '姓名',
  Gender: '性别',
  Address: '地址',
  // 登录页
  Account: '请输入手机号',
  Password: '密码',
  Login: '登录',
  AccountRequired: '账号不能为空',
  CheckUserName: '手机号格式不正确',
  PasswordRequired: '密码不能为空',
  LoginByCaptcha: '验证码登录',
  ForgetPassword: '忘记密码',
  LoginByPassword: '密码登录',
  ResetPassword: '重置密码',
  Settings: '设置',
  UnSet: '未设置',
  AccountSetting: '个人账户设置',
  SetAvatar: '修改头像',
  Change: '变更',
  Phone: '手机号',
  TelPhone: '手机',
  LoginPass: '登录密码',
  ToBind: '绑定',
  SetName: '修改姓名',
  SetSex: '修改性别',
  SetPhone: '修改手机号',
  NewPhone: '新手机号',
  GetCode: '获取验证码',
  CheckCode: '验证码',
  CaptchaRequired: '验证码不能为空',
  ReSend: '重新发送',
  SetEmail: '修改邮箱',
  SetPassword: '修改密码',
  NewPasswordRequired: '新密码不能为空',
  OldPasswordRequired: '旧密码不能为空',
  OldPassword: '旧密码',
  NewPassword: '新密码',
  ConfirmPassword: '确认密码',
  ConfirmPasswordRequired: '请确认密码',
  ConfirmPasswordChecked: '两次密码不一致'
}
